import styled from 'styled-components'

import {Button} from '@miro-site/core'

const TransparentButton = styled(Button).attrs(props => ({
  $styles: {
    ...props.theme.templates.buttons.transparent,
  },
}))``

export default TransparentButton
